import React, {useState} from 'react';
import axios from "axios";

export default function ResetPasswordGetCode({setResetStep, setEmail, email}) {

    const [errorMessage, setErrorMessage] = useState("");
    const [isGettingCode, setIsGettingCode] = useState(false);

    const resetPasswordUrl = "https://www.kipmate.com/manage/wp-json/bdpwr/v1/reset-password"

    const axiosConfig = {
        params: {
            email: email,
        },
    };

    const handleEmailChange = (event) => {
        const inputEmail = event.target.value;
        setEmail(inputEmail);
    };

    const validateEmail = (inputEmail) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const getCode = () => {
        setIsGettingCode(true);
        axios.post(resetPasswordUrl, null, axiosConfig)
            .then((response) => {
                if(response.status === 200) {
                    setErrorMessage("");
                    setResetStep(2);
                }
            })
            .catch((error) => {
                console.error(error);
                setErrorMessage(error.response.data.message || "Something went wrong, please try again");
            })
            .finally(() => {
                setIsGettingCode(false);
            });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validateEmail(email)) {
            getCode();
        } else {
            setErrorMessage("Please enter a valid email address");
        }
    }

    return (
        <>
            <div className=" text-lg">Forgot your password..?</div>

            <div className=" text-base">Enter your email address, and we'll send you a code to reset your password.</div>

            <label className="hidden" htmlFor="email">Email Address</label>
            <input
                className="bg-purple-dashboard focus:outline-none focus:border-light-pink border-dark-pink rounded-lg border-2 h-14 px-4 py-2"
                type="email"
                placeholder="Email"
                id="email"
                name="email"
                value={email}
                onChange={handleEmailChange}
            />

            {errorMessage !== "" ? <p className="text-red-500 text-base m-0">{errorMessage}</p> : null}

            <button onClick={handleSubmit}
                    className="bg-gold-accent hover:bg-gold-accent-hover text-white h-14 px-4 py-2 rounded-lg"
                    disabled={isGettingCode}
            >
                {isGettingCode ? 'Getting code...' : 'Get code'}
            </button>
        </>
    );
}